import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "./Motion";
import { TESTIMONIALS } from "../data/site";

const Stars = () => (
  <div className="flex gap-0.5 text-[#e60000]">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} fill="currentColor" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section
    id="avaliacoes"
    data-testid="testimonials-section"
    className="relative bg-[#050505] py-20 md:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-4 md:px-10">
      <Reveal className="mb-12 md:mb-16 max-w-3xl">
        <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
          / Depoimentos
        </span>
        <h2 className="mt-4 font-display font-bold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
          O que nossos clientes dizem
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.title} delay={(i % 3) * 0.08}>
            <motion.div
              data-testid={`testimonial-${i}`}
              whileHover={{ y: -5 }}
              className="relative h-full bg-[#121212] border border-white/[0.08] p-8 hover:border-[#e60000]/60 transition-colors duration-300"
            >
              <Quote size={40} className="text-[#e60000]/20 absolute top-5 right-5" />
              <Stars />
              <h3 className="mt-4 font-display font-semibold text-white text-lg">
                {t.title}
              </h3>
              <p className="mt-3 text-neutral-400 text-sm leading-relaxed">
                “{t.text}”
              </p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
